<template>
  <div class="text-center">
  	<h2>Please wait... </h2>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { StorageFactory } from '../../../storageFactory'

export const localStore = StorageFactory(() => localStorage)

export default {
  name: 'widget-course-dashboard-setup',
  data: () => {
    return {
      token: '',
      courseId: ''
    }
  },

  mounted () {
    this.loadCourseDashboard()
  },

  methods: {
    ...mapActions([
      'loadUserInfo',
      'loadContinueLearningLast'
    ]),

    loadCourseDashboard () {
      this.token = this.$route.query.refresh_token
      this.courseId = this.$route.query.courseId
      localStore.setItem('token', this.token)
      this.loadUserInfo(this.token).then(resp => {
        let loginTime = (new Date()).getTime()
        localStore.setItem('loginTime', loginTime)
        this.loadContinueLearningLast({uuid: this.courseId, loadDataFromServer: true}).then(options => {
          if (options && options.length > 0) {
            if (options[0].title !== 'COURSE_FINISHED') {
              return this.$router.push({name: 'courseDashboard', params: {uuid: this.courseId, loadLastActivity: true}})
            }
            return this.$router.push({name: 'courseDashboard', params: {uuid: this.courseId}})
          }
          return this.$router.push({name: 'courseDashboard', params: {uuid: this.courseId}})
        })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/app/user/components/WidgetCourseDashboardSetup.vue